import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { useRifm } from 'rifm';
import { useDidUpdateEffect } from '@deliveryhero/armor-system';
import { DateVector } from '../../utils/DateVector';
import { getDatePartsFromString } from '../../utils/getDatePartsFromString';
import { DATERANGEPICKER_DATE_MASK_ACCEPTED_INPUT } from '../constants';
import { DateVectorRange } from '../../utils/DateVectorRange';
import { formatDateTimeMask } from '../utils/formatDateTimeMask';
import { getDateTimeMask } from '../utils/getDateTimeMask';
export var useDateRangePickerMaskedInput = function useDateRangePickerMaskedInput(_ref, props) {
  var formattedValue = _ref.formattedValue,
    inactive = _ref.inactive,
    toggleDropdown = _ref.toggleDropdown,
    setDisplayedDateVector = _ref.setDisplayedDateVector,
    onDateTimeChange = _ref.onDateTimeChange,
    isDateSelectable = _ref.isDateSelectable,
    dropdownOpen = _ref.dropdownOpen;
  var inputMaskEnabled = props.inputMaskEnabled,
    formatDateTime = props.formatDateTime;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputMaskValue = _useState2[0],
    setInputMaskValue = _useState2[1];
  var showMaskedInput = inputMaskEnabled && !formatDateTime;
  var _useRifm = useRifm({
      value: inputMaskValue,
      onChange: setInputMaskValue,
      format: formatDateTimeMask,
      replace: getDateTimeMask,
      accept: DATERANGEPICKER_DATE_MASK_ACCEPTED_INPUT
    }),
    value = _useRifm.value,
    onChange = _useRifm.onChange;
  useDidUpdateEffect(function () {
    if (inputMaskValue !== '' && !showMaskedInput) {
      return;
    }
    var _inputMaskValue$split = inputMaskValue.split('-'),
      _inputMaskValue$split2 = _slicedToArray(_inputMaskValue$split, 2),
      dateStart = _inputMaskValue$split2[0],
      dateEnd = _inputMaskValue$split2[1];
    if (!dateStart || !dateEnd) {
      return;
    }
    var dateStartParts = getDatePartsFromString(dateStart);
    var dateEndParts = getDatePartsFromString(dateEnd);
    if (!dateStartParts || !dateEndParts) {
      return;
    }
    var dayStart = dateStartParts.day,
      monthStart = dateStartParts.month,
      yearStart = dateStartParts.year;
    var dayEnd = dateEndParts.day,
      monthEnd = dateEndParts.month,
      yearEnd = dateEndParts.year;
    var inputMaskStartDateVector = DateVector.createFromStructure({
      year: yearStart,
      month: monthStart,
      day: dayStart
    });
    var inputMaskEndDateVector = DateVector.createFromStructure({
      year: yearEnd,
      month: monthEnd,
      day: dayEnd
    });
    var newVector = new DateVectorRange(inputMaskStartDateVector.clone(), inputMaskEndDateVector.clone());
    var isDateUpdatable = isDateSelectable(inputMaskStartDateVector) && isDateSelectable(inputMaskEndDateVector) && !inputMaskStartDateVector.isEqualTo(inputMaskEndDateVector);
    onDateTimeChange(newVector);
    if (newVector.dateStart && isDateUpdatable) {
      setDisplayedDateVector(newVector.dateStart);
    }
  }, [inputMaskValue, showMaskedInput]);
  useEffect(function () {
    if (showMaskedInput) {
      setInputMaskValue(formattedValue);
    }
  }, [formattedValue, showMaskedInput]);
  return {
    onFocus: function onFocus() {
      if (!inactive && !dropdownOpen) {
        toggleDropdown();
      }
    },
    value: value,
    onChange: onChange,
    showMaskedInput: showMaskedInput
  };
};